import { render, staticRenderFns } from "./QuestionReserve.vue?vue&type=template&id=e2c2afba&scoped=true"
import script from "./QuestionReserve.vue?vue&type=script&lang=js"
export * from "./QuestionReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c2afba",
  null
  
)

export default component.exports